// extracted by mini-css-extract-plugin
export default {"wrapper":"dq-z","response":"eq-z","error":"fq-z","disabled":"gq-z","buttons":"hq-z","feedbackQuestionSection":"iq-z","yesNoWrapper":"jq-z"};